module.exports = "/packs/media/images/oldercouple_Piggyback-e301afdc3eae3a87cb955da533214b4f.jpg";